module.exports = __webpack_public_path__ + "static/media/shuffle.d7782373.svg";